export default {
    template: '<router-view />',
}